import axios from 'axios';
import router from '../router';
import config from './config';

export default function $axios(options) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/', // api 的 base_url
            headers: config.headers,
            timeout: config.timeout,
            withCredentials: config.withCredentials
        });
        // 配置请求拦截
        instance.interceptors.request.use(
            options => {
                // 除了用户登录请求外，每个请求都需要带上jwt令牌
                // 如果没有jwt令牌说明没有登录，重定向到登录页面中
                let token = localStorage.getItem('token')
                if (token) {
                    options.headers.Authentication = token;
                } else if (options.url !== '/api/user/login') {
                    router.push('/login');
                }
                return options
            },
            error => {
                // 请求发生错误时
                console.log('request:', error)
                // 判断请求超时
                if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
                    console.log('timeout请求超时')
                }
                // 需要重定向到错误页面
                const errorInfo = error.response
                console.log(errorInfo)
                if (errorInfo) {
                    error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
                    const errorStatus = errorInfo.status; // 404 403 500 ...
                    router.push({
                        path: `/error/${errorStatus}`
                    })
                }
                return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
            });
        // 配置响应拦截
        instance.interceptors.response.use(
            response => {
                const returnCode = response.data.returnCode
                if (returnCode === 40003) {//jwt令牌无效
                    router.push('/login');
                    return Promise.reject('jwt令牌无效');
                }

                if (response.headers['content-disposition']) {
                    return Object.assign(response.data, { 'fileName': response.headers['content-disposition'] })
                } else {
                    return response.data
                }
            },
            err => {
                if (err && err.response) {
                    switch (err.response.status) {
                        case 400:
                            err.message = '请求错误'
                            break
                        case 401:
                            err.message = '未授权，请登录'
                            break
                        case 403:
                            err.message = '拒绝访问'
                            break
                        case 404:
                            err.message = `请求地址出错: ${err.response.config.url}`
                            break
                        case 408:
                            err.message = '请求超时'
                            break
                        case 500:
                            err.message = '服务器内部错误'
                            break
                        case 501:
                            err.message = '服务未实现'
                            break
                        case 502:
                            err.message = '网关错误'
                            break
                        case 503:
                            err.message = '服务不可用'
                            break
                        case 504:
                            err.message = '网关超时'
                            break
                        case 505:
                            err.message = 'HTTP版本不受支持'
                            break
                        default:
                    }
                }
                console.error(err)
                return Promise.reject(err) // 返回接口返回的错误信息
            }
        );
        // 请求处理
        instance(options).then(res => {
            resolve(res)
            return false
        }).catch(error => {
            reject(error)
        })

    })
}